import "./PrivacyPage.css";
import HeroTitle from "../../layouts/HeroTitle/HeroTitle";

function PrivacyPage() {
  return (
    <div className="privacy-page">
      <HeroTitle title="CHARTE DE PROTECTION DES DONNÉES PERSONNELLES" />

      <div className="privacy-container">
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Introduction</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>La présente charte de protection des données personnelles décrit comment LUMAIN, exploitant le restaurant Tours Bouillon, collecte, utilise et protège vos informations personnelles lorsque vous utilisez notre site web https://toursbouillon.fr/ et nos services.</p>
              <p>Nous nous engageons à protéger votre vie privée et à traiter vos données personnelles de manière transparente et sécurisée, conformément au Règlement Général sur la Protection des Données (RGPD) 2016/679 du 27 avril 2016.</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Responsable du traitement</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p><strong>Raison sociale :</strong> LUMAIN</p>
              <p><strong>Capital social :</strong> 1000 euros</p>
              <p><strong>RCS :</strong> TOURS 930 387 386</p>
              <p><strong>Adresse :</strong> 6 rue des fusillés, 37000 Tours</p>
              <p><strong>Téléphone :</strong> +33247205060</p>
              <p><strong>Email :</strong> toursbouillon@gmail.com</p>
              <p><strong>Numéro TVA :</strong> FR71930387386</p>
              <p><strong>Directeur de publication :</strong> Romain SAUNIER</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Données collectées</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p><strong>Données d'identification :</strong> Nom, prénom, adresse email, numéro de téléphone</p>
              <p><strong>Données de réservation :</strong> Date, heure, nombre de personnes, demandes spéciales</p>
              <p><strong>Données de navigation :</strong> Adresse IP, cookies techniques, pages visitées</p>
              <p><strong>Données de communication :</strong> Messages envoyés via le formulaire de contact</p>
              <p><strong>Données de feedback :</strong> Avis et commentaires sur nos services</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Finalités du traitement</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Vos données personnelles sont collectées pour les finalités suivantes :</p>
              <ul>
                <li>Gestion des réservations de table et de la relation client</li>
                <li>Réponse à vos demandes de contact et d'information</li>
                <li>Amélioration de nos services culinaires et de l'expérience client</li>
                <li>Respect de nos obligations légales et réglementaires</li>
                <li>Administration et maintenance du site web</li>
              </ul>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Base légale</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Le traitement de vos données est fondé sur :</p>
              <ul>
                <li><strong>L'exécution d'un contrat :</strong> Pour la gestion des réservations de restaurant</li>
                <li><strong>L'intérêt légitime :</strong> Pour l'amélioration de nos services et la relation client</li>
                <li><strong>L'obligation légale :</strong> Pour le respect de la réglementation comptable et fiscale</li>
                <li><strong>L'intérêt légitime :</strong> Pour l'administration et la sécurité du site web</li>
              </ul>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Destinataires des données</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Vos données peuvent être partagées avec :</p>
              <ul>
                <li>Notre équipe de service et de cuisine pour la gestion des réservations</li>
                <li>Notre hébergeur OVH SAS pour le stockage sécurisé des données</li>
                <li>Nos prestataires techniques (développeur, maintenance)</li>
                <li>Les autorités compétentes si requis par la loi</li>
              </ul>
              <p>Nous ne vendons jamais vos données personnelles à des tiers commerciaux.</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Durée de conservation</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p><strong>Données de réservation :</strong> 3 ans après la dernière visite</p>
              <p><strong>Données de contact :</strong> 3 ans après la dernière communication</p>
              <p><strong>Données de navigation :</strong> 13 mois maximum</p>
              <p><strong>Données comptables :</strong> 10 ans (obligation légale)</p>
              <p><strong>Avis clients :</strong> Conservation indéfinie sauf demande de suppression</p>
              <p><strong>Données d'authentification :</strong> Conservation pendant la durée d'utilisation du compte</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Vos droits</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul>
                <li><strong>Droit d'accès :</strong> Connaître les données que nous détenons sur vous</li>
                <li><strong>Droit de rectification :</strong> Corriger des données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> Supprimer vos données</li>
                <li><strong>Droit à la limitation :</strong> Limiter le traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> Récupérer vos données dans un format structuré</li>
                <li><strong>Droit d'opposition :</strong> Vous opposer au traitement</li>
              </ul>
              <p>Pour exercer ces droits, contactez-nous à : toursbouillon@gmail.com</p>
              <p><strong>Délai de réponse :</strong> Nous nous engageons à répondre à votre demande dans un délai maximum d'une semaine.</p>
              <p>En cas de litige, vous avez le droit de déposer une plainte auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Sécurité</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :</p>
              <ul>
                <li>L'accès non autorisé</li>
                <li>La divulgation accidentelle</li>
                <li>La modification non autorisée</li>
                <li>La destruction ou la perte</li>
              </ul>
              <p>Nos données sont hébergées de manière sécurisée chez OVH SAS, conformément aux standards de sécurité européens.</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Cookies</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Notre site utilise uniquement des cookies techniques nécessaires au bon fonctionnement :</p>
              <ul>
                <li><strong>Cookies de session :</strong> Pour maintenir votre session de navigation</li>
              </ul>
              <p>Nous n'utilisons aucun cookie de tracking ou de publicité. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Modifications</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Nous nous réservons le droit de modifier cette charte de protection des données personnelles à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour.</p>
              <p>Nous vous recommandons de consulter régulièrement cette page pour rester informé de nos pratiques en matière de protection des données.</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Contact</h2>
            <div className="section-decoration"></div>
            <div className="privacy-info">
              <p>Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous :</p>
              <p><strong>Email :</strong> toursbouillon@gmail.com</p>
              <p><strong>Téléphone :</strong> +33247205060</p>
              <p><strong>Adresse :</strong> 6 rue des fusillés, 37000 Tours</p>
              <p><strong>Directeur de publication :</strong> Romain SAUNIER</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage; 